<template>
  <widget-qrcode v-bind="attrs" :class="ns.b()" width="200" height="200"></widget-qrcode>
</template>

<script setup lang="ts">
import './widget-qrcode.min.js'
import { useAttrs } from 'vue'
import { useNamespace } from '@lit-element/hooks'

const attrs = useAttrs();
defineOptions({
  name: 'LtQrcode',
  inheritAttrs: true,
})

const ns = useNamespace('qrcode')

</script>
